@if (showConfirmationPanel) {
  <div class="confirmation">
    <div class="confirmation-panel_header">
      <span>{{pageTitle | l10n}}</span>
    </div>
    <div class="confirmation-panel_wrapper">
      @switch (state) {
        @case (ConfirmSignUpPageState.SUCCESS_WITH_APPROVAL) {
          <div class="confirmation-panel_text-header">
            {{'components.confirm-sign-up-page.confirm_title' | l10n}}
          </div>
          <div class="confirmation-panel_paragraph">
            {{'components.confirm-sign-up-page.confirm_text_paragraph_1' | l10n}}
          </div>
          <div class="confirmation-panel_paragraph">
            {{'components.confirm-sign-up-page.confirm_text_paragraph_2' | l10n}}
          </div>
        }
        @case (ConfirmSignUpPageState.ERROR) {
          <div class="confirmation-panel_text-header">
            {{'components.confirm-sign-up-page.page_title_expired' | l10n}}
          </div>
          <div class="confirmation-panel_paragraph">
            {{'components.confirm-sign-up-page.confirmation_link_expired' | l10n}}
          </div>
          <div class="confirmation-panel_sign-up-wrapper">
            @if (signUpUrl) {
              <a class="confirmation-panel_sign-up-link" [href]="signUpUrl">
                {{'components.sign-up-page.sign_up' | l10n}}
              </a>
            } @else {
              <a class="confirmation-panel_sign-up-link" [routerLink]="['/signup']">
                {{'components.sign-up-page.sign_up' | l10n}}
              </a>
            }
          </div>
        }
        @case (ConfirmSignUpPageState.SUCCESS_WITHOUT_APPROVAL) {
          <div class="confirmation-panel_text-header">
            {{'components.confirm-sign-up-page.confirm_title' | l10n}}
          </div>
          <div class="confirmation-panel_paragraph">
            {{'components.confirm-sign-up-page.confirm_without_approval_text_paragraph_1' | l10n}}
          </div>
          <div class="confirmation-panel_paragraph">
            {{'components.confirm-sign-up-page.confirm_without_approval_text_paragraph_2' | l10n}}
          </div>
          @if (hasOnboarding && useEmailAsUsername) {
            <div class="confirmation-panel_paragraph">
              {{'components.confirm-sign-up-page.user_id' | l10n:replacementData}}
            </div>
          }
          @if (hasOnboarding) {
            <div class="confirmation-panel_paragraph">
              {{'components.confirm-sign-up-page.onboarding_text' | l10n}}
            </div>
          }
          @if (hasOnboarding) {
            <div class="confirmation-panel_go-to-onboarding-wrapper">
              <a class="confirmation-panel_go-to-onboarding-link" [routerLink]="['/onboarding']">
                {{'components.confirm-sign-up-page.onboarding_link' | l10n}}
              </a>
            </div>
          }
          <div class="confirmation-panel_back-to-login-wrapper">
            <a class="confirmation-panel_back-to-login-link" [routerLink]="['/login']">
              {{'components.confirm-sign-up-page.back_to_login' | l10n}}
            </a>
          </div>
        }
      }
    </div>
  </div>
}
